<script setup lang="ts">
import NavBar from '@/components/navbar/NavBar.vue'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import { watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useToastStore } from '@/stores/toast.store'
import { useRouteAccess } from '@/composables/useRouteAccess.ts'
import ErrorView from './views/ErrorView.vue'
import { useAuthStore } from '@/stores/auth.store'
import { useErrorPageStore } from '@/stores/error-page.store'
import Button from 'primevue/button'

const { hasRouteAccess } = useRouteAccess()
const auth = useAuthStore()
const errorPage = useErrorPageStore()

const toast = useToast()
const toastStore = useToastStore()

watch(
    () => toastStore.toastMessage,
    (msg) => {
        if (msg) {
            toast.add(msg)
            if (msg.group === 'refresh') {
                toastStore.markVersionToastShown()
            }
            toastStore.clearToast()
        }
    }
)
</script>

<template>
    <Toast position="top-right" />
    <Toast group="refresh">
        <template #message="slotProps">
            <div class="flex items-center gap-2 text-nowrap">
                <i
                    class="pi pi-info-circle self-start mt-[var(--bp-spacing-1)]"
                    aria-hidden="true"
                ></i>
                <span>{{ slotProps.message.summary }}</span>
                <Button
                    icon="pi pi-refresh"
                    iconPos="right"
                    class="h-5"
                    text
                    :aria-label="$t('ui.newVersion.refresh')"
                    data-testid="app-version-refresh-button"
                    @click="$router.go(0)"
                />
            </div>
        </template>
    </Toast>
    <ConfirmDialog
        class="max-w-[550px]"
        :pt="{
            content: { class: 'px-10 pt-12 pb-0' },
            footer: { class: 'px-10 pt-12 pb-10 bp-confirm-dialog-footer' },
        }"
    />
    <router-view v-if="hasRouteAccess && !errorPage.status" />
    <template v-else>
        <NavBar v-if="!errorPage.fullscreen" />
        <ErrorView
            :status="errorPage.status ?? (auth.user ? 404 : 401)"
            :fullscreen="errorPage.fullscreen"
        />
    </template>
</template>
